import { projectionGridBulkEdit } from '@bingads-webui-campaign/projection-grid-bulk-edit';

function hotelCenterOverviewBulkEdit(options) {
  const {
    serverContext,
    config,
    filterService,
    gridName,
    hotelCenterI18n,
    BulkEditBidPanel,
    BulkEditBidMultiPanel,
    BulkIncreaseDecreaseBidPanel,
  } = options;

  function getBulkEditBidPanel({ viewConfig, selectedRowCount }) {
    return new BulkEditBidPanel({
      viewConfig,
      selectedRowCount,
      gridName,
      isForVNext: true,
      serverContext,
    });
  }

  const items = [
    {
      text: hotelCenterI18n.getString('HotelCenter_Overview_Edit_Change_Bids_Label'),
      classes: ['bulk-edit-change-bids-option'],
      createView: getBulkEditBidPanel,
    },
    {
      text: hotelCenterI18n.getString('HotelCenter_Overview_Edit_Increase_Decrease_Bids_Label'),
      classes: ['bulk-edit-increase-decrease-bids'],
      createView: ({ viewConfig, selectedRowCount }) => new BulkIncreaseDecreaseBidPanel({
        viewConfig,
        selectedRowCount,
        gridName,
        isForVNext: true,
      }),
    }, {
      classes: ['bulk-edit-change-multipliers-bids'],
      text: hotelCenterI18n.getString('HotelCenter_Overview_Edit_Change_Multipliers_Bids_Label'),
      createView: ({ viewConfig, selectedRowCount }) => new BulkEditBidMultiPanel({
        viewConfig,
        selectedRowCount,
        gridName,
        isForVNext: true,
      }),
    },
  ];

  return projectionGridBulkEdit({
    entityType: 'campaign',
    config,
    filterService,
    i18n: hotelCenterI18n,
    items,
    showDelete: false,
    showEnable: false,
    showPause: false,
    isForVNext: true,
  });
}

export { hotelCenterOverviewBulkEdit };
